/*! @pentacode/ui v0.1.0 */
// src/data/assistant-suggestions.ts
var e = {
	general: {
		label: "Allgemein",
		icon: "icon.object.overview",
		routeMatch: /^dashboard/
	},
	company: {
		label: "Unternehmen",
		routeMatch: /^company/,
		icon: "icon.object.company"
	},
	employeeList: {
		label: "Alle Mitarbeiter",
		routeMatch: /^employees/,
		icon: "icon.object.employee-group"
	},
	employee: {
		label: "Mitarbeiter",
		routeMatch: /^employees/,
		icon: "icon.object.employee"
	},
	recruiting: {
		label: "Recruiting",
		routeMatch: /^recruiting/,
		icon: "icon.object.recruiting"
	},
	accounting: {
		label: "Buchhaltung",
		icon: "icon.object.cash-count",
		routeMatch: /^(settings|revenues)/
	}
}, t = {
	communication: {
		label: "Kommunikation",
		icon: "icon.communication.chat"
	},
	help: {
		label: "Hilfe",
		icon: "icon.action.help"
	},
	mutation: {
		label: "Mutation",
		icon: "icon.action.edit"
	},
	aggregation: {
		label: "Aggregation",
		icon: "icon.object.data-table"
	},
	analysis: {
		label: "Analyse",
		icon: "icon.object.analysis"
	},
	report: {
		label: "Bericht",
		icon: "icon.file.document"
	},
	suggestion: {
		label: "Vorschlag",
		icon: "icon.object.suggestion"
	},
	navigation: {
		label: "Navigation",
		icon: "icon.navigation.shortcut"
	}
}, n = [
	{
		title: "Was gibt es heute Neues?",
		topic: ["general"],
		tags: ["aggregation"],
		icon: "icon.planning.schedule"
	},
	{
		title: "Wie funktionieren Zuschläge?",
		prompt: "Erkläre mir, wie Zuschläge in Pentacode funktionieren",
		topic: ["accounting"],
		tags: ["help"],
		icon: "icon.object.cash-count"
	},
	{
		title: "Sende eine Nachricht an meine Mitarbeiter",
		prompt: "Sende eine Nachricht an diverse meiner Mitarbeiter. Kläre kurz, an welche Mitarbeiter die Nachricht verschickt werden soll und um was es geht. Dann schlage mir einen passenden Text vor, bevor du ihn abschickst.",
		topic: ["employeeList"],
		tags: ["communication"],
		icon: "icon.action.send-message"
	},
	{
		title: "Wie funktioniert die Bewerbungsverwaltung?",
		prompt: "Erkläre mir, wie die Bewerbungsverwaltung in Pentacode funktioniert",
		topic: ["recruiting"],
		tags: ["help"],
		icon: "icon.action.help"
	},
	{
		title: "Wie funktioniert das Recruting?",
		topic: ["recruiting"],
		tags: ["help"],
		icon: "icon.action.help"
	},
	{
		title: "Ausschreibung anpassen",
		prompt: "Ändere aktuelle eine Ausschreibung",
		topic: ["recruiting"],
		tags: ["mutation"],
		icon: "icon.action.edit"
	},
	{
		title: "Bewerber einstellen",
		prompt: "Ich möchte einen Bewerber einstellen, was mache ich?",
		topic: ["recruiting"],
		tags: ["mutation", "help"],
		icon: "icon.action.hire-applicant"
	},
	{
		title: "Mitarbeiter Benefits",
		prompt: "Sage mir, welche Benefits sind für Bewerber neue Mitarbeiter interessant",
		topic: ["recruiting"],
		tags: ["suggestion", "help"],
		icon: "icon.action.help"
	},
	{
		title: "Arbeitszeiten anzeigen",
		prompt: "Öffne Arbeitszeiten aller Mitarbeiter",
		topic: ["employeeList"],
		tags: ["navigation"],
		icon: "icon.object.date-range"
	},
	{
		title: "Arbeitszeiten nach Abteilungen",
		prompt: "Filtere Arbeitszeiten nach Abteilungen",
		topic: ["employeeList"],
		tags: ["navigation"],
		icon: "icon.object.time-history"
	},
	{
		title: "Kranktage in Q1",
		prompt: "Wie viele Kranktage gab es in im ersten Quartal dieses Jahres?",
		topic: ["employeeList"],
		tags: ["aggregation", "analysis"],
		icon: "icon.time-entry.sick"
	},
	{
		title: "Arbeitszeiten von Mitarbeiter",
		prompt: "Exportiere mir die Arbeitszeiten von einem ",
		topic: ["employee"],
		tags: ["aggregation", "report"],
		icon: "icon.object.date-range"
	},
	{
		title: "AZ-Nachweise exportieren",
		prompt: "Exportiere alle Arbeitszeit-Nachweise für den aktuellen Monat",
		topic: ["accounting"],
		tags: ["aggregation", "report"],
		icon: "icon.action.download"
	},
	{
		title: "Lohndaten exportieren",
		prompt: "Exportiere alle Lohndaten für den aktuellen Monat",
		topic: ["accounting"],
		tags: ["aggregation", "report"],
		icon: "icon.action.download"
	},
	{
		title: "Lohnbericht für diesen Monat",
		prompt: "Erstelle einen Lohnbericht für den aktuellen Monat",
		topic: ["accounting"],
		tags: ["aggregation", "report"],
		icon: "icon.object.payroll-report"
	},
	{
		title: "Erkärung Übertrag/Soll/Ist/Differenz/Saldo",
		prompt: "Was bedeutet Übertrag, Soll, Ist, Differenz und Saldo in Pentacode?",
		topic: ["accounting"],
		tags: ["help"],
		icon: "icon.action.help"
	},
	{
		title: "Nachricht an Mitarbeiter",
		prompt: "Schreibe eine Nachricht an einen Mitarbeiter",
		topic: ["employee"],
		tags: ["communication"],
		icon: "icon.action.send-message"
	},
	{
		title: "Nachricht an alle Mitarbeiter",
		prompt: "Schreibe eine Nachricht an alle Mitarbeiter",
		topic: ["employeeList"],
		tags: ["communication"],
		icon: "icon.action.send-message"
	},
	{
		title: "Urlaubskonto öffnen",
		topic: ["employee"],
		tags: ["navigation"],
		icon: "icon.time-entry.vacation"
	},
	{
		title: "Urlaubstage in Q2",
		prompt: "Wie viele Urlaubstage wurden in Q2 genommen?",
		topic: ["employeeList"],
		tags: ["aggregation"],
		icon: "icon.time-entry.vacation"
	},
	{
		title: "Zuschlagskonto öffnen",
		prompt: "Öffne das Zuschlagskonto",
		topic: ["employee"],
		tags: ["navigation"],
		icon: "icon.action.pay-out"
	},
	{
		title: "Urlaubs-Zuwachs Berechnung",
		prompt: "Wie wird der Urlaubs-Zuwachs berechnet?",
		topic: ["employee"],
		tags: ["help"],
		icon: "icon.action.help"
	},
	{
		title: "Exportiere die Urlaubstage",
		prompt: "Exportiere alle Urlaubstage für den gewählten Zeitraum",
		topic: ["employee"],
		tags: ["aggregation", "report"],
		icon: "icon.action.download"
	},
	{
		title: "Neue Stellenanzeige",
		prompt: "Erstelle eine neue Stellenanzeige",
		topic: ["recruiting"],
		tags: ["mutation"],
		icon: "icon.object.recruiting"
	},
	{
		title: "Stellenanzeige Bearbeiten",
		prompt: "Bearbeite die Stellenanzeige",
		topic: ["recruiting"],
		tags: ["mutation"],
		icon: "icon.action.edit"
	},
	{
		title: "Stellenanzeigen vergleichen",
		prompt: "Vergleiche bitte Stellenanzeigen",
		topic: ["recruiting"],
		tags: ["analysis"]
	},
	{
		title: "Gibt es Bewerbungen?",
		topic: ["recruiting"],
		tags: ["aggregation"]
	},
	{
		title: "Was bedeutet Pauschale?",
		topic: ["employee", "employeeList"],
		tags: ["help"],
		icon: "icon.action.help"
	},
	{
		title: "Wie kann ich Zuschläge zuweisen?",
		topic: ["employee"],
		tags: ["help"],
		icon: "icon.action.help"
	},
	{
		title: "Nachzahlung von Zuschlägen",
		prompt: "Müssen Zuschläge pauschal nachgezahlt werden?",
		topic: ["employee", "employeeList"],
		tags: ["help"],
		icon: "icon.action.help"
	},
	{
		title: "Urlaub eintragen",
		prompt: "Ich möchte Urlaub für einen Mitarbeiter eintragen",
		topic: ["employee"],
		tags: ["mutation"],
		icon: "icon.time-entry.vacation"
	},
	{
		title: "Krankmeldung eintragen",
		prompt: "Ich möchte eine Krankmeldung für einen Mitarbeiter eintragen",
		topic: ["employee", "employeeList"],
		tags: ["mutation"],
		icon: "icon.time-entry.sick"
	},
	{
		title: "Offene Urlaubsanträge anzeigen",
		prompt: "Zeig mir alle offene Urlaubsanträge",
		topic: ["employee"],
		tags: ["navigation"],
		icon: "icon.time-entry.vacation"
	},
	{
		title: "Vergangene Urlaube anzeigen",
		prompt: "Zeig mir alle vergangenen Urlaube von diesem Jahr",
		topic: ["employee"],
		tags: ["navigation"],
		icon: "icon.time-entry.vacation"
	},
	{
		title: "Vorschuss buchen",
		prompt: "Ich möchte einen Gehaltsvorschuss für einen Mitarbeiter buchen",
		topic: ["employee", "accounting"],
		tags: ["mutation"],
		icon: "icon.action.book-advance"
	},
	{
		title: "Analyse Vorschüsse",
		prompt: "Wann wurden die meisten Vorschüsse gezahlt?",
		topic: ["accounting"],
		tags: ["analysis", "aggregation"]
	},
	{
		title: "Adresse von Mitarbeiter ändern",
		prompt: "Kannst du die Adresse des Mitarbeiters anpassen?",
		topic: ["employee"],
		tags: ["mutation"],
		icon: "icon.object.address"
	},
	{
		title: "Telefonnummer von Mitarbeiter ändern",
		prompt: "Kannst du die Telefonnummer des Mitarbeiters anpassen?",
		topic: ["employee"],
		tags: ["mutation"],
		icon: "icon.communication.phone"
	},
	{
		title: "PIN von Mitarbeiter ändern",
		prompt: "Kannst du die PIN des Mitarbeiters anpassen?",
		topic: ["employee"],
		tags: ["mutation"]
	},
	{
		title: "Verträge vergleichen",
		prompt: "Vergleich bitte die Veträge von zwei Mitarbeitern",
		topic: ["employee"],
		tags: ["analysis"]
	},
	{
		title: "Gehalt vergleichen",
		prompt: "Vergleich bitte das Gehalt von zwei Mitarbeitern",
		topic: ["employee"],
		tags: ["analysis"]
	},
	{
		title: "Urlaub vergleichen",
		prompt: "Vergleich bitte den Urlaub von zwei Mitarbeitern",
		topic: ["employee"],
		tags: ["analysis"]
	},
	{
		title: "Nächste Geburtstage",
		prompt: "Wer hat in nächster Zeit Geburtstag",
		topic: ["general", "employee"],
		tags: ["aggregation", "analysis"]
	},
	{
		title: "Aktuelle Abwesenheiten",
		prompt: "Gibt es aktuell neue Krankmeldungen oder Urlaubsanträge",
		topic: ["general", "employee"],
		tags: ["aggregation", "analysis"]
	},
	{
		title: "Auslaufende Probezeiten",
		prompt: "Welche Probezeiten laufen demnächst aus?",
		topic: ["general", "employee"],
		tags: ["aggregation", "analysis"],
		icon: "icon.status.probation-ending"
	},
	{
		title: "Kann ich im Dashboard Veränderungen vornehmen?",
		topic: ["general"],
		tags: ["aggregation", "analysis"],
		icon: "icon.action.help"
	},
	{
		title: "Neue Notiz",
		prompt: "Erstelle mir eine neue Notiz",
		topic: ["general"],
		tags: ["mutation"],
		icon: "icon.action.add-note"
	},
	{
		title: "Wie kann ich einen Vertrag bearbeiten?",
		topic: ["employee"],
		tags: ["help"],
		icon: "icon.object.contract"
	},
	{
		title: "Wie ändere ich in einem bestehenden Vertrag etwas?",
		topic: ["employee"],
		tags: ["help"],
		icon: "icon.object.contract"
	},
	{
		title: "Neuer Vertrag",
		prompt: "Lege einen neuen Vertrag an",
		topic: ["employee"],
		tags: ["mutation"],
		icon: "icon.object.contract"
	},
	{
		title: "Verträge öffnen",
		prompt: "Öffne die Verträge aller Mitarbeitenden",
		topic: ["employee"],
		tags: ["navigation"],
		icon: "icon.object.contract"
	},
	{
		title: "Was ist ein Verwaltungszugang",
		topic: ["general", "employee"],
		tags: ["help"],
		icon: "icon.object.permissions"
	},
	{
		title: "Wie kann ich Rechte verwalten?",
		topic: ["general", "employee"],
		tags: ["help"],
		icon: "icon.object.permissions"
	},
	{
		title: "Wie kann ich Rechte verwalten?",
		topic: ["general", "employee"],
		tags: ["help"],
		icon: "icon.object.permissions"
	},
	{
		title: "Öffne Zugänge und Rechte",
		topic: ["employee"],
		tags: ["navigation"],
		icon: "icon.object.permissions"
	},
	{
		title: "Wie lade ich die MA zur App ein?",
		topic: ["general", "employee"],
		tags: ["help"],
		icon: "icon.action.send-message"
	},
	{
		title: "Filtere die Positionen nach Abteilung XY",
		topic: ["general", "employee"],
		tags: ["help"],
		icon: "icon.action.send-message"
	},
	{
		title: "Öffne die Abwesenheiten",
		prompt: "Öffne die Abwesenheits-Übersicht",
		topic: ["employee"],
		tags: ["navigation"],
		icon: "icon.object.absence"
	},
	{
		title: "Gibt es neue Urlaubsanträge",
		prompt: "Zeig mir alle neuen Urlaubsanträge",
		topic: ["employee"],
		tags: ["aggregation"],
		icon: "icon.time-entry.vacation"
	},
	{
		title: "Welcher MA hatte schon den meisten Urlaub?",
		prompt: "Welcher Mitarbeiter hatte bisher den meisten Urlaub in diesem Jahr?",
		topic: ["employee"],
		tags: ["analysis", "aggregation"],
		icon: "icon.time-entry.vacation"
	},
	{
		title: "Filtere nach Abteilungen",
		prompt: "Filtere die Mitarbeiter oder Ansicht nach verschiedenen Abteilungen",
		topic: ["employee"],
		tags: ["navigation"],
		icon: "icon.object.work-area"
	},
	{
		title: "Öffne die digitale Personalakte",
		prompt: "Öffne die digitale Personalakte",
		topic: ["employee"],
		tags: ["navigation"],
		icon: "icon.file.collection"
	},
	{
		title: "Öffne Konten Übersicht",
		prompt: "Öffne die Konten-Übersicht aller Mitarbeiter",
		topic: ["accounting"],
		tags: ["navigation"],
		icon: "icon.object.time-balance"
	},
	{
		title: "Was sind SFN Zuschläge",
		prompt: "Erkläre mir was SFN Zuschläge sind",
		topic: ["accounting"],
		tags: ["help"],
		icon: "icon.action.help"
	},
	{
		title: "Erkläre mir den Unterschied zwischen Beitragsfrei und Beitragspflichtig",
		prompt: "Was ist der Unterschied zwischen beitragsfreien und beitragspflichtigen Zuschlägen?",
		topic: ["accounting", "general"],
		tags: ["help"],
		icon: "icon.action.help"
	},
	{
		title: "Zeige mir das letzte Quartal",
		prompt: "Zeige mir die Daten des letzten Quartals",
		topic: ["accounting", "employee"],
		tags: ["aggregation", "analysis"],
		icon: "icon.object.revenue-overview"
	},
	{
		title: "Wie ändere ich Personalnummern?",
		prompt: "Wie kann ich Personalnummern von Mitarbeitern ändern?",
		topic: ["employee"],
		tags: ["help", "mutation"],
		icon: "icon.action.help"
	},
	{
		title: "Exportiere die Stammdaten",
		prompt: "Exportiere alle Stammdaten der Mitarbeiter",
		topic: ["employee"],
		tags: ["aggregation", "report"],
		icon: "icon.object.master-data"
	},
	{
		title: "Wie kann ich Positionen hinzufügen",
		prompt: "Wie kann ich neue Positionen/Stellen hinzufügen?",
		topic: ["employee"],
		tags: ["help", "mutation"],
		icon: "icon.action.help"
	},
	{
		title: "Kann ein Mitarbeiter mehrere Positionen haben",
		prompt: "Kann ein Mitarbeiter mehrere Positionen gleichzeitig haben?",
		topic: ["employee"],
		tags: ["help"],
		icon: "icon.action.help"
	},
	{
		title: "Wie mache ich eine Zeitbuchung?",
		prompt: "Erkläre mir, wie ich eine Zeitbuchung in Pentacode mache",
		topic: ["employee"],
		tags: ["help"],
		icon: "icon.action.help"
	},
	{
		title: "Kranktage vergleichen",
		prompt: "Vergleiche die Kranktage von verschiedenen Mitarbeitern",
		topic: ["employee"],
		tags: ["analysis", "aggregation"]
	},
	{
		title: "Arbeitszeiten vergleichen",
		prompt: "Vergleiche die Arbeitszeiten von verschiedenen Mitarbeitern",
		topic: ["employee"],
		tags: ["analysis", "aggregation"],
		icon: "icon.object.working-hours"
	},
	{
		title: "Setze diesen Mitarbeiter auf Entlassen",
		prompt: "Setze den Status eines Mitarbeiters auf entlassen",
		topic: ["employee"],
		tags: ["mutation"],
		icon: "icon.action.dismiss-employee"
	},
	{
		title: "Überstunden ausbezahlen",
		prompt: "Zahle die Überstunden eines Mitarbeiters aus",
		topic: ["accounting", "employee"],
		tags: ["mutation"],
		icon: "icon.action.pay-out"
	},
	{
		title: "Urlaubstage vergleichen",
		prompt: "Vergleiche die Urlaubstage von verschiedenen Mitarbeitern",
		topic: ["employee"],
		tags: ["analysis", "aggregation"],
		icon: "icon.time-entry.vacation"
	},
	{
		title: "Sollstunden für Aushilfen berechnen",
		prompt: "Wie werden die Sollstunden für Aushilfen berechnet?",
		topic: ["employee"],
		tags: ["help", "analysis"],
		icon: "icon.action.help"
	},
	{
		title: "Lohn-Zusammensetzung",
		prompt: "Zeige mir die Lohn-Zusammensetzung eines Mitarbeiters",
		topic: ["accounting"],
		tags: ["analysis", "aggregation"],
		icon: "icon.action.help"
	},
	{
		title: "Urlaub buchen",
		prompt: "Führe eine Urlaubsbuchung für einen Mitarbeiter durch",
		topic: ["employee"],
		tags: ["mutation"],
		icon: "icon.time-entry.vacation"
	},
	{
		title: "Wie viele Zuschläge wurden gezahlt?",
		prompt: "Zeige mir, wie viele Zuschläge in einem bestimmten Zeitraum gezahlt wurden",
		topic: ["accounting"],
		tags: ["aggregation", "analysis"],
		icon: "icon.action.help"
	},
	{
		title: "Kind Krank eintragen",
		prompt: "Trage eine Kind-Krank-Meldung für einen Mitarbeiter ein",
		topic: ["employee"],
		tags: ["mutation"],
		icon: "icon.action.report-child-sick"
	},
	{
		title: "Neue Telefonnummer hinterlegen",
		prompt: "Hinterlege eine neue Telefonnummer für einen Mitarbeiter",
		topic: ["employee"],
		tags: ["mutation"],
		icon: "icon.communication.phone"
	},
	{
		title: "Neue Mailadresse hinterlegen",
		prompt: "Hinterlege eine neue E-Mail-Adresse für einen Mitarbeiter",
		topic: ["employee"],
		tags: ["mutation"],
		icon: "icon.action.send-message"
	},
	{
		title: "PIN Ändern",
		prompt: "Ändere die PIN eines Mitarbeiters",
		topic: ["employee"],
		tags: ["mutation"],
		icon: "icon.action.set-password"
	},
	{
		title: "Gehalt erhöhen",
		prompt: "Erhöhe das Gehalt eines Mitarbeiters",
		topic: ["employee", "accounting"],
		tags: ["mutation"],
		icon: "icon.action.raise-salary"
	},
	{
		title: "Erkläre die Einstellungen für Sollstunden",
		topic: ["employee"],
		tags: ["help"],
		icon: "icon.action.help"
	},
	{
		title: "Kassenbuch exportieren",
		prompt: "Exportiere das Kassenbuch für den gewählten Zeitraum",
		topic: ["accounting"],
		tags: ["aggregation", "report"],
		icon: "icon.action.download"
	}
];
export { e as suggestionTopics, n as suggestions, t as suggestionsTags };

//# sourceMappingURL=assistant-suggestions.js.map